import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'did_the_fac_have_any_other_wage_deductions_besides_legally_requ'

export const dataPointDefinition = {
  retracedId: 'did_the_fac_have_any_other_wage_deductions_besides_legally_requ',
  name: 'Did the facility have any other wage deductions (besides legally required withholdings and social security)?',
  description:
    "The intent of this question is to understand if the facility deducts any money from wages outside of legal withholdings and social security. \r\r\n\r\r\nIn other words, this question is asking about deductions OTHER THAN legally required withholdings (those that are mandatory/involuntary). \r\r\n\r\r\nIf the facility deducts any type of other amount from the worker's overall wages (i.e. for housing/food etc.), answer Yes.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-19',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8840,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
